import { FormControl, InputLabel, 
    Select, MenuItem, IconButton, Tooltip } from "@mui/material";
import RPService from "../../rpService";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

function CSLanguage ({ createEnabled, selectedLanguage, setSelectedLanguage, copyAll }) {

    return (
      <div style={{ display: "flex" }}>
        <FormControl
          sx={{ flex: "auto" }}
          key="languageSelectFormControl"
        >
          <InputLabel id="languageSelectLabel">Language</InputLabel>
          <Select
            labelId="languageSelectLabel"
            id="languageSelect"
            value={selectedLanguage}
            label="Language"
            onChange={(e) => setSelectedLanguage(e.target.value)}
          >
            <MenuItem value="en">English</MenuItem>
            {RPService.getLanguages().map((l) => {
              return (
                <MenuItem key={l.id} value={l.id}>
                  {l.label}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        {selectedLanguage !== "en" && (
          <Tooltip title="Copy all from EN">
            <IconButton id="copyall" onClick={(e) => copyAll(e)}>
              <ContentCopyIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
    );
}

export default CSLanguage;